// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__zhe7Z","egplayaelement0a":"gallery_egplayaelement0a__gSW8g","titleLink":"gallery_titleLink__XN3fh","arrow":"gallery_arrow__Z7Q5z"};